import { ConstraintsService } from "shared/services/ConstraintsService";
import { create } from "./store";

type ConstraintsProductStoreState = {
  products: any;
  microcategories: any;

	isSearchingProducts: boolean;

  //** search products and microcategories */
  productsSearchResults: any[];
  microcategoriesSearchResults: any[];
  //** end search products and microcategories */
};

type ConstraintsProductStoreActions = {
  setProducts: (products: any) => void;
  setMicrocategories: (microcategories: any) => void;

  //** search products and microcategories */
  fetchSearchProducts: (productSearchString: string) => Promise<void>;
  resetProductsSearchResults: () => void;
  fetchSearchMicrocategories: (
    microCategorySearchString: string,
  ) => Promise<void>;
  resetMicrocategoriesSearchResults: () => void;
  //**  */

  resetStore: () => void;
};

const initialData: ConstraintsProductStoreState = {
  products: null,
  microcategories: null,

	isSearchingProducts: false,

  //** search products and microcategories */
  productsSearchResults: [],
  microcategoriesSearchResults: [],
  //** */
};

const constraintsProductMicrocatsStore = create<
  ConstraintsProductStoreState & ConstraintsProductStoreActions
>()((set, get) => ({
  ...initialData,
  setProducts: (products) => {
    set({ products: products });
  },
  setMicrocategories: (microcategories) => {
    set({ microcategories: microcategories });
  },

  //** search products and microcategories */
  fetchSearchMicrocategories: async (microCategorySearchString: string) => {
    if (microCategorySearchString.length > 0) {
      const results = await ConstraintsService.searchMicroCategories(
        microCategorySearchString,
      );
      set({ microcategoriesSearchResults: results });
    } else {
      set({ microcategoriesSearchResults: [] });
    }
  },
  fetchSearchProducts: async (productSearchString: string) => {
    if (productSearchString.length > 0) {
			set({ isSearchingProducts: true });
      const results: any[] =
        await ConstraintsService.searchProducts(productSearchString);
      set({ productsSearchResults: results });
			set({ isSearchingProducts: false });
    } else {
      set({ productsSearchResults: [] });
			set({ isSearchingProducts: false });
    }
  },
  resetProductsSearchResults: () => {
    set({ productsSearchResults: [] });
		set({ isSearchingProducts: false });
  },
  resetMicrocategoriesSearchResults: () => {
    set({ microcategoriesSearchResults: [] });
  },
  //**  */

  resetStore: () => {
    set(initialData);
  },
}));

export default constraintsProductMicrocatsStore;
